
Acr = window.Acr || {};

Acr.WebVitals = (function (window) {
  function sendPerformanceActivity(object) {
    if (window.Acr.trackingObject && !window.Acr.trackingObject.initialize_in_code) {
      const performanceObject = {
        Page: {
          page_name: Acr.trackingObject ? Acr.trackingObject.Page.page_name : '',
          full_url: window.location.href,
          device_name: '',
          viewport: '',
          browser: '',
          date: new Date(),
        },
        WebVitals: {},
      };

      Object.keys(window.Acr.TrackingManager.webVitals).forEach((key) => {
        const measure = {
          metric_name: window.Acr.TrackingManager.webVitals[key].name,
          metric_value: window.Acr.TrackingManager.webVitals[key].value,
          metric_delta: window.Acr.TrackingManager.webVitals[key].delta,
        };
        performanceObject.WebVitals[key] = measure;
      });
      if (window.ModelData) {
        performanceObject.Model = {};
        performanceObject.Model.model_name = window.ModelData.model;
        performanceObject.Model.model_year = window.ModelData.modelYear;
      }
      Acr.TrackingManager.sendPerformanceActivity(performanceObject);
    }
  }

  function updateWebVitalsObject(object) {
    if (window && window.Acr && window.Acr.TrackingManager) {
      window.Acr.TrackingManager.webVitals[object.name] = object;
    }
  }

  function init() {
    const webVitals = window.webVitals || undefined;
    if (window.Acr && window.Acr.TrackingManager) { window.Acr.TrackingManager.webVitals = []; }
    const Acr = window.Acr || {};
    if (webVitals && Acr.isWebVitalsEnabled) {
      webVitals.getCLS(updateWebVitalsObject, true);
      webVitals.getFID(updateWebVitalsObject);
      webVitals.getLCP(updateWebVitalsObject, true);
    }

    window.addEventListener('beforeunload', () => {
      if (Acr && Acr.TrackingManager && Acr.TrackingManager.webVitals) {
        sendPerformanceActivity(Acr.TrackingManager.webVitals);
      }
    });
  }

  return {
    init: init,
  };
}(window));

addEventListener('DOMContentLoaded', () => {
  Acr.WebVitals.init();
});
